import { createFileRoute } from "@tanstack/react-router";
import { NttpcMaintenanceSettings } from "@/features/maintenance/NttpcMaintenanceSettings";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_dashboard/nttpc-maintenances/")({
  component: NttpcMaintenancesPage,
});

function NttpcMaintenancesPage() {
  usePageTitle("メンテナンス設定");
  return <NttpcMaintenanceSettings />;
}
